// extracted by mini-css-extract-plugin
export default {"calendarWrapper":"ActivityCalendar__calendarWrapper___CQrdq","calendarHeader":"ActivityCalendar__calendarHeader___R5148","navButton":"ActivityCalendar__navButton___W0tm7"};